import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import theme from './theme/theme';
import { AuthProvider } from './context/authcontext';
import { ScanningProvider } from './context/scanContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ScanningProvider>
          <App />
        </ScanningProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
